/**
 * Created by Fedor on 26.08.2026
 */

FogBlock.prototype.displayCondition = function () {
    const homefix = Homefix.currentHomefix;

    cleverapps.centerHint.createTextHint(Messages.get("Home.collectStars"));

    const currentUnit = homefix.getCurrentFurniture().unit;
    if (currentUnit) {
        homefix.map.focusOnUnit(currentUnit);
    }
};
